import type { ComparisonConfig } from './ComparisonPage';

const HOTELOGIX_JA: ComparisonConfig = {
  slug: 'hotelstack-vs-hotelogix',
  competitorName: 'Hotelogix',
  heroTitle: 'HotelStack.io vs Hotelogix',
  heroSubtitle: '主要なホテル管理プラットフォーム2社の包括的な比較。HotelStack.ioがHotelogixよりも多くの機能、最新のアーキテクチャ、優れた価値を提供する理由をご覧ください。',
  overviewComparison: [
    { label: 'モジュール総数', hotelstack: '36の統合モジュール', competitor: '15モジュール' },
    { label: 'アーキテクチャ', hotelstack: 'クラウドネイティブSaaS', competitor: 'レガシークラウド' },
    { label: 'グローバル展開', hotelstack: '40か国以上', competitor: '主にアジア' },
    { label: 'チャネルマネージャー', hotelstack: '内蔵（100以上のOTA）', competitor: 'アドオン必須' },
    { label: '予約エンジン', hotelstack: 'BookMyRoom.io（無料）', competitor: '基本ウィジェット' },
    { label: 'サポート', hotelstack: '24時間365日専任サポート', competitor: 'メール＋チャット' },
  ],
  featureTable: [
    {
      category: '基幹PMS',
      features: [
        { name: 'ビジュアルルームボード', hotelstack: true, competitor: true },
        { name: 'ドラッグ＆ドロップチェックイン', hotelstack: true, competitor: false },
        { name: 'ナイトオーディットウィザード', hotelstack: true, competitor: true },
        { name: 'ゲストフォリオ管理', hotelstack: true, competitor: true },
        { name: 'オンラインチェックインポータル', hotelstack: true, competitor: false },
        { name: 'ウォークイン予約モーダル', hotelstack: true, competitor: '制限あり' },
      ],
    },
    {
      category: 'レベニューマネジメント',
      features: [
        { name: 'ダイナミックプライシングルール', hotelstack: true, competitor: false },
        { name: 'What-If収益シミュレーター', hotelstack: true, competitor: false },
        { name: '競合料金モニター', hotelstack: true, competitor: false },
        { name: '需要予測', hotelstack: true, competitor: false },
        { name: 'RevPAR分析', hotelstack: true, competitor: '基本' },
      ],
    },
    {
      category: 'ゲスト管理',
      features: [
        { name: '360度ゲストプロファイル', hotelstack: true, competitor: '基本' },
        { name: 'ロイヤルティプログラム管理', hotelstack: true, competitor: false },
        { name: 'ゲストコミュニケーション自動化', hotelstack: true, competitor: '制限あり' },
        { name: 'ゲスト消費分析', hotelstack: true, competitor: false },
        { name: 'ID/写真アップロード', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'F&B・POS',
      features: [
        { name: 'POSターミナル', hotelstack: true, competitor: false },
        { name: 'テーブルフロアプラン', hotelstack: true, competitor: false },
        { name: 'キッチンディスプレイシステム', hotelstack: true, competitor: false },
        { name: 'ルームサービスモジュール', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'レポート・分析',
      features: [
        { name: 'フラッシュレポート', hotelstack: true, competitor: true },
        { name: '損益計算書', hotelstack: true, competitor: false },
        { name: 'ペースレポート', hotelstack: true, competitor: false },
        { name: '税務コンプライアンスレポート', hotelstack: true, competitor: '基本' },
        { name: 'カスタムレポートビルダー', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'マルチプロパティ',
      features: [
        { name: 'チェーンダッシュボード', hotelstack: true, competitor: true },
        { name: 'クロスプロパティ分析', hotelstack: true, competitor: false },
        { name: '一元レート管理', hotelstack: true, competitor: false },
        { name: 'ブランド設定', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'レジリエンスとオフライン',
      features: [
        { name: 'オフライン対応PWA', hotelstack: true, competitor: false },
        { name: 'オフライン更新キュー', hotelstack: true, competitor: false },
        { name: '再接続時のバックグラウンド同期', hotelstack: true, competitor: false },
        { name: '競合を検知する照合', hotelstack: true, competitor: false },
        { name: 'インストール可能なフロントデスク', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '法人・団体セールス',
      features: [
        { name: '法人料金管理', hotelstack: true, competitor: false },
        { name: 'ルーミングリスト付き団体予約', hotelstack: true, competitor: 'アドオン' },
        { name: '売掛金年齢分析・実績レポート', hotelstack: true, competitor: false },
        { name: 'レストラン予約', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'スタッフ・人事',
      features: [
        { name: 'スタッフ名簿・シフト管理', hotelstack: true, competitor: false },
        { name: '給与計算', hotelstack: true, competitor: false },
        { name: '休暇・勤怠管理', hotelstack: true, competitor: false },
        { name: 'パフォーマンス分析', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$60+',
    hotelstackNote: '36モジュールすべて含む。機能制限なし。無料オンボーディングとデータ移行。EUR、GBP、AED、INR、THBでの地域別料金設定。',
    competitorNote: '限定モジュールの基本プラン。チャネルマネージャーや高度な機能は追加料金。',
  },
  advantages: [
    'モジュール数が2倍以上（36対15）、コア機能にアドオン料金なし',
    '2024年構築の最新クラウドネイティブアーキテクチャで全デバイスとリアルタイム同期',
    '6通貨での地域別料金設定と40か国以上のコンプライアンスツールによる多通貨対応',
    'BookMyRoom.ioによる内蔵予約エンジン — 手数料無料のダイレクト予約を含む',
    'ダイナミックプライシング、需要予測、What-Ifシミュレーターを備えた高度なレベニューマネジメント',
    'テーブル管理、キッチンディスプレイ、ルームサービスを含む完全なF&B・POSモジュール',
    '基本プランにより多くの機能を含む低価格の開始価格',
    '専任オンボーディングサポート付きのHotelogixからの無料データ移行',
  ],
  verdict: {
    title: '総合評価',
    summary: 'HotelStack.ioは、最新のオールインワンプラットフォームを求めるホテルにとってより優れた選択肢です。36モジュール、内蔵レベニューマネジメント、F&B機能、低価格により、Hotelogixよりも大幅に優れた価値を提供します。Hotelogixは基本的なPMS機能のみを必要とする格安ホテルに適している場合があります。',
    bestFor: [
      'アドオン料金なしの最新オールインワンプラットフォームを求めるホテル',
      '高度なレベニューマネジメントとダイナミックプライシングが必要な施設',
      'F&B、POS、ルームサービス機能が必要なホテル',
      '地域別コンプライアンスと多通貨請求が必要な施設',
      '一元分析とレート管理が必要なマルチプロパティチェーン',
    ],
  },
  faqItems: [
    { question: 'HotelogixからHotelStack.ioに移行できますか？', answer: 'はい。当社チームがゲストプロファイル、予約履歴、料金プラン、客室設定を含むHotelogixからの完全なデータ移行を担当します。移行は無料で、通常48時間以内にダウンタイムゼロで完了します。' },
    { question: 'HotelStack.ioにはHotelogixが提供するすべての機能がありますか？', answer: 'HotelStack.ioには、Hotelogixが提供するすべての機能に加え、レベニューマネジメント、F&B/POS、ロイヤルティプログラム、コンプライアンスツール、高度な分析を含む17の追加モジュールが含まれています。' },
    { question: 'HotelStack.ioとHotelogixの料金比較は？', answer: 'HotelStack.ioは月額$49からで36モジュールすべて含む。EUR、GBP、AED、INR、THBでの地域別料金設定が利用可能。Hotelogixは基本プランで約$60/月から、チャネルマネージャーやその他の機能は追加料金。' },
    { question: '現在Hotelogixを使用している小規模ホテルにHotelStack.ioは適していますか？', answer: 'もちろんです。スタータープランは50室までの施設向けに設計されており、すべての機能がアンロックされています。多くの小規模ホテルが追加モジュールと低価格のためにHotelogixから乗り換えています。' },
  ],
};

const CLOUDBEDS_JA: ComparisonConfig = {
  slug: 'hotelstack-vs-cloudbeds',
  competitorName: 'Cloudbeds',
  heroTitle: 'HotelStack.io vs Cloudbeds',
  heroSubtitle: '両方ともクラウドネイティブプラットフォームです。HotelStack.ioはCloudbedsにはない、より多くのモジュール、低価格、完全なF&B/POS機能を、多通貨地域別料金設定で提供します。',
  overviewComparison: [
    { label: 'モジュール総数', hotelstack: '36モジュール', competitor: '20以上のモジュール' },
    { label: '料金', hotelstack: '月額$49から', competitor: '月額$100以上' },
    { label: '地域別料金', hotelstack: '6通貨対応', competitor: 'USDのみ' },
    { label: 'F&B / POS', hotelstack: '内蔵', competitor: '利用不可' },
    { label: '予約エンジン', hotelstack: 'BookMyRoom.io（無料）', competitor: '基本ウィジェット' },
    { label: 'オンボーディング', hotelstack: '無料＋専任', competitor: 'セルフサービス' },
  ],
  featureTable: [
    {
      category: '基幹PMS',
      features: [
        { name: 'ビジュアルルームボード', hotelstack: true, competitor: true },
        { name: '予約管理', hotelstack: true, competitor: true },
        { name: 'グループ予約', hotelstack: true, competitor: true },
        { name: 'ナイトオーディットウィザード', hotelstack: true, competitor: true },
        { name: 'オンラインチェックインポータル', hotelstack: true, competitor: true },
      ],
    },
    {
      category: '地域コンプライアンス',
      features: [
        { name: '多通貨請求', hotelstack: true, competitor: '制限あり' },
        { name: '地域税自動化', hotelstack: true, competitor: false },
        { name: 'ゲスト登録コンプライアンス', hotelstack: true, competitor: false },
        { name: 'GDPRデータ保護', hotelstack: true, competitor: true },
        { name: '地域決済ゲートウェイ', hotelstack: true, competitor: '制限あり' },
        { name: 'ローカライズ請求書', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'レベニューマネジメント',
      features: [
        { name: 'ダイナミックプライシング', hotelstack: true, competitor: true },
        { name: '収益分析', hotelstack: true, competitor: true },
        { name: '競合料金モニター', hotelstack: true, competitor: 'アドオン' },
        { name: 'What-Ifシミュレーター', hotelstack: true, competitor: false },
        { name: '需要予測', hotelstack: true, competitor: '基本' },
      ],
    },
    {
      category: 'F&B・オペレーション',
      features: [
        { name: 'POSターミナル', hotelstack: true, competitor: false },
        { name: 'ルームサービスモジュール', hotelstack: true, competitor: false },
        { name: 'ハウスキーピングボード', hotelstack: true, competitor: true },
        { name: 'メンテナンス作業指示', hotelstack: true, competitor: false },
        { name: 'スタッフスケジューリング', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'コンプライアンス・レポート',
      features: [
        { name: '地域税レポート', hotelstack: true, competitor: false },
        { name: '監査証跡', hotelstack: true, competitor: true },
        { name: '損益計算書', hotelstack: true, competitor: '制限あり' },
        { name: 'カスタムレポートビルダー', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'レジリエンスとオフライン',
      features: [
        { name: 'オフライン対応PWA', hotelstack: true, competitor: false },
        { name: 'オフライン更新キュー', hotelstack: true, competitor: false },
        { name: '再接続時のバックグラウンド同期', hotelstack: true, competitor: false },
        { name: '競合を検知する照合', hotelstack: true, competitor: false },
        { name: 'インストール可能なフロントデスク', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '法人・団体セールス',
      features: [
        { name: '法人料金管理', hotelstack: true, competitor: false },
        { name: 'ルーミングリスト付き団体予約', hotelstack: true, competitor: '制限あり' },
        { name: '売掛金年齢分析・実績レポート', hotelstack: true, competitor: false },
        { name: 'レストラン予約', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'スタッフ・人事',
      features: [
        { name: 'スタッフ名簿・シフト管理', hotelstack: true, competitor: 'アドオン' },
        { name: '給与計算', hotelstack: true, competitor: false },
        { name: '休暇・勤怠管理', hotelstack: true, competitor: false },
        { name: 'パフォーマンス分析', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$100+',
    hotelstackNote: '36モジュールすべて含む。EUR、GBP、AED、INR、THBでの地域別料金設定。無料オンボーディングと移行。',
    competitorNote: 'USD限定料金（月額$100以上）。プレミアム機能とインテグレーションは追加料金。',
  },
  advantages: [
    '全36モジュールを約半額で提供 — コア機能にアドオン料金なし',
    '6通貨での地域別料金設定 — 国際施設に為替レートの驚きなし',
    'POSターミナル、ルームサービス、キッチン管理を含む完全なF&Bモジュール',
    '税自動化、ゲスト登録、GDPRのための地域コンプライアンスツール',
    'PaymentHooks.com経由のマルチゲートウェイ決済対応（Stripe、PayPal、50以上のゲートウェイ）',
    '給与、勤怠、シフトスケジューリングを含むスタッフ管理モジュール',
    '資産追跡機能付きメンテナンス・作業指示管理',
    '専任サポートチーム付きの無料オンボーディングとデータ移行',
  ],
  verdict: {
    title: '総合評価',
    summary: 'HotelStack.ioは、Cloudbedsの約半額で、より多くのモジュール、優れた価値、完全な運用ツールを提供します。Cloudbedsは基本的なPMSとチャネル管理には堅実なプラットフォームですが、HotelStack.ioはF&B/POS、スタッフ管理、メンテナンス、高度な収益ツールを追加 — すべて基本価格に含まれています。',
    bestFor: [
      '低価格で完全なオールインワンプラットフォームを求めるホテル',
      'F&B、POS、スタッフ管理を一つのシステムで必要とする施設',
      '地域コンプライアンスと多通貨請求を求めるホテル',
      'セルフサービスセットアップより専任オンボーディングを希望する施設',
      '一元分析とレート管理が必要なマルチプロパティチェーン',
    ],
  },
  faqItems: [
    { question: 'CloudbedsからHotelStack.ioに移行できますか？', answer: 'はい。オンボーディングチームがゲストプロファイル、予約履歴、料金プランを含むCloudbedsからの完全なデータ移行を担当します。移行は無料で、通常48時間以内に完了します。' },
    { question: 'HotelStack.ioはCloudbedsと同じOTAチャネルに対応していますか？', answer: 'はい。HotelStack.ioはBooking.com、Expedia、Airbnb、Agoda、地域プラットフォームを含む100以上のOTAに接続します。AmadeusとSabreによるGDS接続もサポートしています。' },
    { question: 'なぜHotelStack.ioはCloudbedsより手頃なのですか？', answer: 'HotelStack.ioはすべてのプランに36モジュールすべてをアドオン料金なしで含みます。6通貨での地域別料金設定でさらにコストを削減。Cloudbedsはプレミアム機能に追加料金がかかり、USD料金のみです。' },
    { question: 'HotelStack.ioは海外の施設でも使えますか？', answer: 'もちろんです。HotelStack.ioは多通貨請求、地域税コンプライアンス、国際決済ゲートウェイをサポートしています。40か国以上のホテルがHotelStack.ioで運営を管理しています。' },
  ],
};

const MEWS_JA: ComparisonConfig = {
  slug: 'hotelstack-vs-mews',
  competitorName: 'Mews',
  heroTitle: 'HotelStack.io vs Mews',
  heroSubtitle: 'Mewsはプレミアム料金と有料導入でエンタープライズホテルをターゲットにしています。HotelStack.ioは、より多くのモジュールを含む同じモダンな体験を、わずかなコストで提供します — 無料オンボーディング付き。',
  overviewComparison: [
    { label: 'ホテルセグメント', hotelstack: '中小企業からエンタープライズ', competitor: 'エンタープライズのみ' },
    { label: '料金', hotelstack: '月額$49から', competitor: '月額$200以上' },
    { label: 'モジュール総数', hotelstack: '36内蔵', competitor: '15以上コア' },
    { label: 'F&B / POS', hotelstack: '内蔵', competitor: 'インテグレーション経由' },
    { label: 'UI/UX品質', hotelstack: 'モダンダークラグジュアリー', competitor: 'モダンミニマル' },
    { label: 'オンボーディング', hotelstack: '無料＋専任', competitor: '有料導入' },
  ],
  featureTable: [
    {
      category: '基幹PMS',
      features: [
        { name: 'クラウドネイティブアーキテクチャ', hotelstack: true, competitor: true },
        { name: 'モダンUI/UX', hotelstack: true, competitor: true },
        { name: 'リアルタイム同期', hotelstack: true, competitor: true },
        { name: 'マルチデバイスアクセス', hotelstack: true, competitor: true },
        { name: 'ナイトオーディット自動化', hotelstack: true, competitor: true },
      ],
    },
    {
      category: '地域コンプライアンス',
      features: [
        { name: '多通貨請求', hotelstack: true, competitor: true },
        { name: '地域税自動化', hotelstack: true, competitor: 'EUのみ' },
        { name: 'ゲスト登録コンプライアンス', hotelstack: true, competitor: 'EUのみ' },
        { name: 'GDPRデータ保護', hotelstack: true, competitor: true },
        { name: '地域決済ゲートウェイ', hotelstack: true, competitor: '制限あり' },
        { name: '地域別料金設定（6通貨）', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '収益・流通',
      features: [
        { name: 'チャネルマネージャー', hotelstack: true, competitor: true },
        { name: 'ダイナミックプライシング', hotelstack: true, competitor: true },
        { name: '予約エンジン', hotelstack: true, competitor: true },
        { name: '収益分析', hotelstack: true, competitor: true },
        { name: 'What-Ifシミュレーター', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'オペレーション',
      features: [
        { name: 'ハウスキーピング管理', hotelstack: true, competitor: true },
        { name: 'POS / F&Bモジュール', hotelstack: true, competitor: 'インテグレーション経由' },
        { name: 'スタッフスケジューリング', hotelstack: true, competitor: false },
        { name: 'メンテナンス/作業指示', hotelstack: true, competitor: false },
        { name: 'ゲストコミュニケーション', hotelstack: true, competitor: true },
      ],
    },
    {
      category: '料金・サポート',
      features: [
        { name: '無料オンボーディング', hotelstack: true, competitor: false },
        { name: '無料データ移行', hotelstack: true, competitor: false },
        { name: '24時間365日サポート', hotelstack: true, competitor: '営業時間内' },
        { name: '導入費用なし', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'レジリエンスとオフライン',
      features: [
        { name: 'オフライン対応PWA', hotelstack: true, competitor: false },
        { name: 'オフライン更新キュー', hotelstack: true, competitor: false },
        { name: '再接続時のバックグラウンド同期', hotelstack: true, competitor: false },
        { name: '競合を検知する照合', hotelstack: true, competitor: false },
        { name: 'インストール可能なフロントデスク', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '法人・団体セールス',
      features: [
        { name: '法人料金管理', hotelstack: true, competitor: 'アドオン' },
        { name: 'ルーミングリスト付き団体予約', hotelstack: true, competitor: true },
        { name: '売掛金年齢分析・実績レポート', hotelstack: true, competitor: 'アドオン' },
        { name: 'レストラン予約', hotelstack: true, competitor: 'インテグレーション経由' },
      ],
    },
    {
      category: 'スタッフ・人事',
      features: [
        { name: 'スタッフ名簿・シフト管理', hotelstack: true, competitor: 'インテグレーション経由' },
        { name: '給与計算', hotelstack: true, competitor: false },
        { name: '休暇・勤怠管理', hotelstack: true, competitor: false },
        { name: 'パフォーマンス分析', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$200+',
    hotelstackNote: '36モジュールすべて含む。無料オンボーディングと移行。6通貨での地域別料金設定。',
    competitorNote: 'エンタープライズ料金（月額$200以上）。有料の導入とオンボーディング。プレミアムサポートは別料金。',
  },
  advantages: [
    'すべてのプランにより多くのモジュールを含み、開始価格が約75%低い',
    'Mewsの有料導入に対して、無料オンボーディングとデータ移行',
    'Mewsのサードパーティインテグレーション要件に対して、完全なF&BとPOSが内蔵',
    '6通貨での地域別料金設定 — ホテルは現地通貨で支払い',
    'スタッフ管理、給与、シフトスケジューリングを含む',
    'メンテナンスと作業指示管理をプラットフォームに内蔵',
    'Mewsの営業時間サポートに対して24時間365日専任サポート',
    'エンタープライズだけでなく中小企業にもアクセス可能 — すべてのプランにすべてのモジュールを含む',
  ],
  verdict: {
    title: '総合評価',
    summary: 'Mewsはプレミアム料金を支払う意欲のあるエンタープライズホテルにとって優れたプラットフォームです。HotelStack.ioは、F&B/POS、スタッフ管理、メンテナンスモジュールを追加しながら、モダンなUXとクラウドアーキテクチャでMewsに匹敵します — すべて約4分の1の価格で無料オンボーディング付き。',
    bestFor: [
      'Mews品質のUXをより手頃な価格で求めるホテル',
      'F&B、POS、運用ツールが内蔵されている必要がある施設',
      '有料導入費用なしの無料オンボーディングを求めるホテル',
      'Mewsのエンタープライズプランでは予算が合わない中小規模の施設',
      '地域コンプライアンスを備えた一元管理が必要なマルチプロパティチェーン',
    ],
  },
  faqItems: [
    { question: 'UI品質の面でHotelStack.ioはMewsとどう比較されますか？', answer: '両プラットフォームとも、モダンで直感的なインターフェースを提供しています。HotelStack.ioはホスピタリティ業界向けに特別に設計されたダークラグジュアリーテーマを採用し、1つのダッシュボードから36の統合モジュールにアクセスできます。Mewsはヨーロッパのワークフローに焦点を当てたクリーンでミニマルなデザインです。' },
    { question: 'MewsにはF&BとPOS機能が含まれていますか？', answer: 'MewsはF&BとPOSにサードパーティインテグレーションが必要です。HotelStack.ioには、完全なPOSターミナル、ルームサービスモジュール、キッチンディスプレイシステム、ダイニング管理がすべてのプランの標準機能として含まれています。' },
    { question: 'Mewsと同じモダンな体験をより低価格で得られますか？', answer: 'はい。HotelStack.ioはリアルタイム同期、美しいUI、36モジュールを月額$49で提供します（Mewsは月額$200以上）。さらにオンボーディングと移行は無料です。' },
    { question: 'HotelStack.ioはMewsのようなAPIインテグレーションを提供しますか？', answer: 'はい。HotelStack.ioは決済ゲートウェイ、OTA、会計ソフトウェア、サードパーティサービス向けのAPIを備えたインテグレーションマーケットプレイスを提供しています。APIファーストアーキテクチャはエンタープライズ要件のカスタムインテグレーションをサポートしています。' },
  ],
};

export const COMPARISON_JA: Record<string, ComparisonConfig> = {
  'hotelstack-vs-hotelogix': HOTELOGIX_JA,
  'hotelstack-vs-cloudbeds': CLOUDBEDS_JA,
  'hotelstack-vs-mews': MEWS_JA,
};
